<template>
  <div class="fh-nest-table">
    <fh-table :tableSkeletonRows="5" ref="fhTableRef" :columns="columns" :data="tableData" :pagination="pagination" :bordered="false" :loading="loading" @paginationEvent="onPaginationEvent" :active-row-type="'single'" row-key="id" :expandIcon="hasNextLevel" v-model:expandedRowKeys="expandedRowKeys" :activeRowKeys="activeRowKeys" :isChildren="true" @expandChange="rehandleExpandChange" @columnResize="columnResize" @rowMouseover="rowMouseover" @rowMouseLeave="rowMouseLeave" :tableLevel="tableLevel" :checkedParams="{ width: 40 }">
      <template #prefix="{ col }">
        <!-- 字段图标 -->
        <component :is="getFieldIcn(col)" />
      </template>

      <template #customTitleCheckbox>
        <span></span>
      </template>

      <!-- 自定义复选框 -->
      <template #customCheckbox="{ row }">
        <!-- buttonBatch.length &&  -->
        <div class="handle-container">
          <!-- <div class="handle-icon move-icon">
            <qfei-icon-full-screen-outlined />
          </div> -->

          <jw-tooltip content="查看详情">
            <div class="handle-icon detail-icon" @click.stop="openDetails(row)">
              <qfei-icon-full-screen-outlined />
            </div>
          </jw-tooltip>
        </div>
      </template>

      <!-- <template #table-cell-suffix-0-0="{ row, width }">
        <jw-tooltip content="查看详情">
          <div class="detail-icon" @click.stop="openDetails(row)">
            <qfei-icon-detail-page-outlined />
            <template v-if="Number(width) >= 120">详情</template>
          </div>
        </jw-tooltip>
      </template> -->
      <!-- 展开行图标 -->
      <template #expandIcon="{ rowKey }">
        <div class="expand-icon-container">
          <qfei-icon-caret-right-outlined v-if="!expandedRowKeys.includes(rowKey)" style="font-size: 10px" />
          <qfei-icon-caret-down-outlined v-else style="font-size: 10px" />
        </div>
      </template>
      <!-- 递归加载多层级内容 -->
      <template #expandRow="{ row }">
        <!-- 只传递三个核心属性和两个内部属性 -->
        <fh-nest-table v-if="hasNextLevel" :parentEntity="getCurrentLevelMultiTable()?.businessDataEntity" :multiTable="getNextLevelMultiTable()" :parentId="row?.id" :tableLevel="tableLevel + 1" />
      </template>
    </fh-table>
  </div>
  <ly-detail ref="detailRef" @cb="refreshList"></ly-detail>
</template>

<script setup>
import FhTable from '../fh-table/fh-table.vue';
import { publicService, layoutService } from '@/api/';
import { ref, watch, computed, onMounted, provide, inject, onBeforeUnmount } from 'vue';
import { useTableConfig } from '@/hooks/table-config';
import useFields from '@/hooks/fields';
import { QfeiIconCaretRightOutlined, QfeiIconCaretDownOutlined, QfeiIconFullScreenOutlined } from '@qfei-design/icons-vue';
const { fieldIconMapping } = useFields(); // 获取字段图标
// 定义props - 只保留三个核心参数和必要的内部参数
const props = defineProps({
  // 核心参数 - 外部传入
  parentEntity: { type: Number, default: 0 }, // 实体ID
  multiTable: { type: Object, default: () => ({}) }, // 当前层级配置信息
  parentId: { type: Number, default: 0 }, // 展开行的数据id
  tableLevel: { type: Number, default: 2 } // 表格层级
  // 内部参数 - 递归调用时使用
});
const specialProduct = [7, 9, 11, 14, 32]; //特殊产品对象
// 定义列配置变量，用于自动推导或使用外部提供的列
// 初始化为外部提供的列，如果没有提供则为空数组，在initCurrentLevelColumns中填充
const columns = ref([]);
const fhTableRef = ref(null);

const getFieldIcn = (field) => {
  return fieldIconMapping.value[Number(field.fieldType)];
};

const entityRef = ref(props.parentEntity);
// const tableLevelListScroll = ref(320); //多层级限高
const loading = ref(false);
const parentId = ref(props.parentId);
// 打开详情页面
const openDetails = (record) => {
  // 获取对象entity
  const { businessDataEntity } = getCurrentLevelMultiTable();
  if (specialProduct.includes(Number(businessDataEntity))) {
    //特殊产品显示不能点击状态
    return false;
  }
  setEntity.value = businessDataEntity;
  setId.value = record?.id;
  detailRef.value.openDialog();
};

const { getTableLevelEntity, getComputedErrorLog, AssTableData, getColumns } = useTableConfig(entityRef);

// 分页配置 - 使用默认配置
const pagination = ref({
  current: 1,
  pageSize: 5,
  total: 0,
  showSizeChanger: true,
  pageSizeOptions: [5, 10]
});
// 计算属性
// const pagination = computed(() => paginationObj.value);

// 展开行相关 - 内部管理展开状态
const expandedRowKeys = ref([]);

const multiTable = ref(props.multiTable || {});

// 定义内部状态变量
const tableData = ref([]);

// 获取层级配置信息
const getCurrentLevelMultiTable = () => {
  return {
    multiTableConfig: props.multiTable,
    businessDataEntity: getTableLevelEntity(props.multiTable)
  };
};

// 获取当前表格数据
const getTableEntityData = async (isLoading = true) => {
  // 始终使用当前层级的配置信息
  loading.value = isLoading;
  const { multiTableConfig, businessDataEntity } = getCurrentLevelMultiTable();
  // 使用props.entity作为关联对象entity
  const itselfTableEntity = entityRef.value;

  let layoutId = null; // 布局id
  let layoutConfigId = null; // 布局的id
  let businessId = null; // 数据id

  layoutId = multiTableConfig?.layoutId;
  layoutConfigId = multiTableConfig?.id;
  businessId = parentId.value; // 数据id

  // 如果没有业务ID，则不进行请求
  if (!businessId) {
    console.warn('没有业务ID，无法获取数据');
    return;
  }

  const params = {
    itselfTableEntity: itselfTableEntity,
    tableEntity: businessDataEntity,
    layoutId: layoutId,
    layoutConfigId: layoutConfigId,
    businessId: businessId, // 数据id
    page: pagination.value.current,
    pageSize: pagination.value.pageSize,
    apiIndex: `${businessDataEntity}_${businessId}_${Math.random() * 100}`
  };

  try {
    const res = await publicService.getTableEntityData(params);
    if (!res.error) {
      const rt = res.result;
      const businessIdList = rt.records.map((rItem) => rItem.id);
      const computedInfo = await getComputedErrorLog(businessIdList, businessDataEntity);
      const processedData = AssTableData(rt.records, computedInfo);

      // 始终更新当前层级数据，因为现在只关注当前层级
      // 无论是第几层，都应该更新自己的数据
      tableData.value = processedData;
      pagination.value = {
        ...pagination.value,
        current: rt.current,
        total: rt.total,
        page: rt.page
      };
    }
    loading.value = false;
  } catch (e) {
    loading.value = false;
  }
};

// 分页相关
const onPaginationEvent = async (current, pageSize) => {
  pagination.value.current = current;
  pagination.value.pageSize = pageSize;
  await getTableEntityData(false);
};

const setEntity = ref();
const setId = ref();
const detailRef = ref(); //公共抽离组件
const hasNextLevel = ref(false);

// 获取下一层级的multiTable配置
const getNextLevelMultiTable = () => {
  // 查找当前配置中的type=31模块，作为下一级的配置
  const nextLevelModule = props.multiTable?.modules?.find((fItem) => fItem.type == 31);
  return nextLevelModule || null;
};

// 从当前层级的multiTable中推导列配置
const initCurrentLevelColumns = () => {
  // 始终从 multiTable 推导列配置，不使用外部提供的 columns
  // 获取当前层级的multiTable配置
  const currentMultiTable = props.multiTable;
  if (!currentMultiTable) return;
  columns.value = getColumns(currentMultiTable, { updateFieldPermission }, props.tableLevel);
};

const updateFieldPermission = async ({ fieldValue, businessId, fieldKey }) => {
  try {
    const dataIndex = tableData.value?.findIndex((td) => td?.id == businessId);
    if (dataIndex == -1) {
      return false;
    }
    // 获取对象entity
    const { businessDataEntity } = getCurrentLevelMultiTable();
    const res = await layoutService.fieldPermission({
      type: 'ID',
      value: businessId,
      entity: businessDataEntity,
      source: 4
    });
    if (!res?.error) {
      const _tv = tableData.value[dataIndex];
      _tv['PERMISSION'] = res?.result?.permissions || {};
      //因为行内编辑是临时显示，表格数据不会变，这里更新一下，不然重渲规则会丢失最新的值
      _tv[fieldKey] = fieldValue;
    }
    return [];
  } catch (e) {
    console.log(e);
  }
};

// 在组件初始化时获取数据
onMounted(async () => {
  // 检查是否有下一层级
  const nextLevelConfig = getNextLevelMultiTable();
  hasNextLevel.value = !!nextLevelConfig;
  // 初始化列配置
  initCurrentLevelColumns();

  // 检查是否有展开行数据
  if (props.parentId) {
    await getTableEntityData(true);
  }
});

onBeforeUnmount(() => {
  // 清理组件引用
  fhTableRef.value = null;
  detailRef.value = null;
  // 清理响应式数据
  columns.value = [];
  tableData.value = [];
  expandedRowKeys.value = [];
  // 清理provide的依赖
  provide('defaultParams', null);
  provide('nestTableMethods', null);
  provide('tableMethods', null);
});

watch(
  () => props.multiTable,
  (newVal) => {
    multiTable.value = newVal;
  },
  { deep: true }
);

const refreshList = async () => {
  //刷新2 3级表格数据 如果有展开数据的话
  await getTableEntityData(false);
};

provide('defaultParams', {
  id: computed(() => setId.value),
  entity: computed(() => setEntity.value),
  columns: computed(() => columns.value),
  viewId: '' //兼容多层级表格
});
provide('nestTableMethods', {
  toDetails: openDetails
});
const tableScrollToTop = inject('mainTableMethods')?.tableScrollToTop;
// 表格行滚动事件-->参数：params：{ direction: 'left' | 'right' | 'top' | 'bottom'， distance: number, distance: number }，direction：滚动方向，distance：滚动距离
const tableScrollEvent = async (params) => {
  //例如： params = { direction: 'left', distance: 100 };
  console.log('tableScrollEvent', params);
  if (fhTableRef.value) {
    if (params?.y < 0) {
      tableScrollToTop?.({ distance: params.y });
    }
    fhTableRef.value?.tableScrollEvent({ y: undefined, ...params });
  }
};
// 提供修改行数据的z-index方法
const updateZIndex = ({ rowKey, zIndex }) => {
  if (!fhTableRef.value) return;
  fhTableRef.value?.updateZIndex({ rowKey, zIndex });
};
// 获取左侧固定列最后一列到视口左侧的距离
const getFixedLeftLastCellRect = () => {
  return fhTableRef.value?.getFixedLeftLastCellRect(props.tableLevel);
};

provide('tableMethods', {
  tableScrollEvent: tableScrollEvent,
  getFixedLeftLastCellRect: getFixedLeftLastCellRect,
  updateZIndex: updateZIndex
});
</script>
<style scoped lang="less">
@import './fh-nest-table.less';
</style>
